module.exports = __webpack_public_path__ + "static/media/emailPreview.7847a6ac.png";